export default "__VITE_ASSET__52f1f309__"